import * as React from 'react';
import { translate } from 'react-i18next';
import { IPortalSectionProps } from 'models/portal/page/portalpagesection';
import * as c from 'models/constants';
import { browserHistory } from 'react-router';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import * as i18n from 'i18next';

interface IProps extends IPortalSectionProps {
	t?: (key: string, options?: any) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType11 extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { section } = this.props;

		const handleNavigate = (redirectPath: string) => {
			browserHistory.push(redirectPath);
		};

		const renderElements = () => {
			let categoryName = '';
			const redirectUrl = {
				0: '',
				1: '',
				2: '',
				3: '',
				4: '',
				5: '',
			};
			///////////////////////////////////////////////////
			// SingleHero
			///////////////////////////////////////////////////
			return section.items.map((x, index) => {
				const item = x.elements[1] as ISectionTextElement;
				categoryName = item?.categoryName;
				redirectUrl[index] = item?.redirectUrl;

				return (
					<div key={index} className="pointer" onClick={() => handleNavigate(redirectUrl[index])}>
						<p className="white">{categoryName}</p>
					</div>
				);
			});
		};

		return (
			<div className="row">
				<div className="col-lg-12">
					<div className="portalPageSectionType11">
						<h3>{i18n.t('PortalPage_Section_Manage_SectionTitle_ShopByCategory')}</h3>
						<div className="categoriesCotaniner d-flex flex-row">{renderElements()}</div>
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType11 };
